import React, { useEffect, useState, useRef, useMemo } from "react";
import { getValue } from "@utils/lodash";
import { adminUpdateBulkStatusCheckpoint } from "@services/checkpoint.service";
import { useNavigate, useParams } from "react-router-dom";
import NavigationBar from "@components/NotificationBar/index";
import DeleteModal from "@_common/deleteModal";
import { toast } from "react-toastify";
import PaginationPage from "@components/pagination/pagination";
import Notfound from "@components/Not-Found";
import Search from "@components/common/Search";
import { Label, Modal, ModalBody } from "reactstrap";
import InputField from "@_common/InputRuleFeild";
import {
  clientCreateVerifiedHeadCount,
  clientDeleteBulkHeadCount,
  clientDeleteSpecificHeadCount,
  clientGetHeadcount,
} from "@services/vendors.service";
import SimpleReactValidator from "simple-react-validator";
import { clientGetLocation } from "@services/location.service";
import "./index.scss";
import Loader from "@components/common/Loader";
import { QueryRequestHelper } from "@_common/query-request-helper";
import DashboardLayout from "@layouts/dashboard/dashboard-layout";
import { NavLink } from "react-router-dom";
import moment from "moment";
import SearchableDropdownSelect from "@_common/SearchableDropdown";
import ScrollableReactTable from "@components/ScrollableDatatable";
import MenuAuditSvgComponent from "../../../../../assets/svg-components/left-menu/menuadit";
import RightMenuHeaders from "@components/common/RightMenuHeaders";
import ReactTooltip from "react-tooltip";
import { getManageAuditScoreFilter } from "@services/audit.service";
import { sanitizeInput } from "@_common/dompurify";

interface IVendorsDetailInfoUsersProps {}

const AuditHeadCount: React.FunctionComponent<IVendorsDetailInfoUsersProps> = (
  props: any
) => {
  let navigate = useNavigate();
  let orgParams = useParams();
  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */
  const simpleValidator = useRef(new SimpleReactValidator());
  const [, forceUpdate] = useState(0);

  const [months] = useState([
    { label: "January", value: 1 },
    { label: "February", value: 2 },
    { label: "March", value: 3 },
    { label: "April", value: 4 },
    { label: "May", value: 5 },
    { label: "June", value: 6 },
    { label: "July", value: 7 },
    { label: "August", value: 8 },
    { label: "September", value: 9 },
    { label: "October", value: 10 },
    { label: "November", value: 11 },
    { label: "December", value: 12 },
  ]);

  const [monthsArray] = useState([
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ]);
  const [years, setYears] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState<any>("");
  const [selectedMonth, setSelectedMonth] = useState<any>("");
  const [selectedYear, setSelectedYear] = useState<any>("");
  const [isLoading, setIsLoading] = React.useState(false);
  const [list, setList] = React.useState<[]>([]);
  const [locationList, setLocationList] = useState([]);
  const [isFilterVisible, setFilterVisibility] = React.useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const handleModal = () => {
    setIsOpen(!isOpen);
  };
  const handleModalCancel = () => {
    setIsOpen(!isOpen);
    reset();
    // setEdit(false);
    // setEditId("");
    // setGroup_name("");
  };

  const [edit, setEdit] = useState(false);
  const [editId, setEditId] = useState("");
  const handleModalEdit = (item: object) => {
    setEdit(true);
    setRequest({
      ...request,
      verified_headcount: getValue(item, `original.verified_headcount`, ""),
      verified_male: getValue(item, `original.verified_male`, ""),
      verified_female: getValue(item, `original.verified_female`, ""),
      month: getValue(item, `original.month`, ""),
      year: getValue(item, `original.year`, ""),
    });
    let month = months.filter(
      (items: object) =>
        getValue(items, `value`, "") == getValue(item, `original.month`, "")
    );
    let year = years.filter(
      (items: object) =>
        getValue(items, `value`, "") == getValue(item, `original.year`, "")
    );
    let location = locationList.filter(
      (items: object) =>
        getValue(items, `id`, "") == getValue(item, `original.location.id`, "")
    );
    setSelectedMonth(getValue(month, `length`, 0) > 0 ? month[0] : {});
    setSelectedYear(getValue(year, `length`, 0) > 0 ? year[0] : {});
    // setSelectedLocation(getValue(location, `length`, 0) > 0 ? location[0] : {});
    setEditId(getValue(item, `original.id`, ""));
    handleModal();
  };

  const [request, setRequest] = useState<any>({
    verified_headcount: "",
    verified_male: "",
    verified_female: "",
    month: "",
    year: "",
    vendor_id: orgParams.id,
  });
  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length === 0 && props.permissionAPITriggered) {
      getData();
    }
    getLocationData("");

    let currentYear = 2022;
    let count = 2022 + 1000;
    let yearList: any = [];
    Array.from({ length: count }, (v, k) => k).map((k) => {
      if (k >= currentYear) {
        return yearList.push({
          value: `${k}`,
          label: `${k}`,
        });
      }
    });
    setYears(yearList);
  }, [props.permissionAPITriggered]);

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length > 0 && props.permissionAPITriggered) {
      getData();
      if (params.page_no) {
        setPage_no(parseInt(params.page_no));
      }
      if (params.search_text) {
        setSearchInput(params.search_text);
        setShowSearchTextbox(true);
      }
      if (params.limit) {
        setLimit(parseInt(params.limit));
      }
    }
  }, [window.location.href, props.permissionAPITriggered]);

  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */

  const getLocationData = async (id: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());

    let payload: any = {
      // page_no: params.page_no ? parseInt(params.page_no) : 1,
      // page_size: 10,
      // search_text: params.search_text,
      // sort_by: params.sort_by,
      // is_active: true,
      // id: id,
      month: orgParams.date.split("-")[1],
      year: orgParams.date.split("-")[0],
      type: "LOCATION",
      search_text: search_text,
      location_id: id,
      page_size:  100,
      vendor_id: orgParams.id,
    };
    let queryRequest = QueryRequestHelper(payload);
    try {
      // let resp = await clientGetLocation(queryRequest);
      let resp = await getManageAuditScoreFilter(queryRequest);

      if (resp) {
        setIsLoading(false);
        let filtered = getValue(resp, `data.vendors_checkpoint`, []).map(
          (item: object) => ({
            ...item,
            // status: getValue(item, `is_active`, false) ? "Active" : "Inactive",
            // city_name: getValue(item, `city.name`, ""),
            value: getValue(item, `location_name`, ""),
            label: getValue(item, `location_name`, ""),
          })
        );
        // let filtered = getValue(resp, `data.locations`, []).map(
        //   (item: object) => ({
        //     ...item,
        //     status: getValue(item, `is_active`, false) ? "Active" : "Inactive",
        //     city_name: getValue(item, `city.name`, ""),
        //     value: getValue(item, `location_name`, ""),
        //     label: getValue(item, `location_name`, ""),
        //   })
        // );
        if (id) {
          console.log(filtered, "===Filtered===>")
          setSelectedLocation(filtered[0]);
        }
        setLocationList(getValue(filtered, `length`, 0) > 0 ? filtered : []);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  console.log(selectedLocation, "===selectedLocation===>")
  const getData = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());

    let payload: any = {
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: params.limit ? parseInt(params.limit) : limit,
      search_text: params.search_text,
      sort_by: params.sort_by,
      vendor_id: orgParams.id,
      month: orgParams.date.split("-")[1],
      year: orgParams.date.split("-")[0],
    };
    let queryRequest = QueryRequestHelper(payload);
    try {
      setIsLoading(true);
      let resp = await clientGetHeadcount(queryRequest);
      if (resp) {
        setIsLoading(false);
        setList(
          getValue(resp, `data.headcounts`, []).map((item: object) => ({
            ...item,
            yearMonth:
              monthsArray[parseInt(getValue(item, `month`, "")) - 1] +
              " - " +
              getValue(item, `year`, ""),
            location_name: getValue(item, `location.location_name`, ""),
            vendor_name: getValue(item, `vendor.vendor_name`, ""),
          }))
        );
        setTotalCount(getValue(resp, `data.pagination.total`, 0));
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const handleChangeActiveStatus = async () => {
    try {
      let resp = await adminUpdateBulkStatusCheckpoint({
        ids: selectedIDs,
        is_active: false,
      });
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        setSelectedIDs([]);
        getData();
      }
    } catch (error) {}
  };

  const calculateHeadCount = () => {
    let headcount = getValue(request, `verified_headcount`, 0)
      ? parseInt(getValue(request, `verified_headcount`, 0))
      : (getValue(request, `verified_male`, 0)
          ? parseInt(getValue(request, `verified_male`, 0))
          : 0) +
        (getValue(request, `verified_female`, 0)
          ? parseInt(getValue(request, `verified_female`, 0))
          : 0);
    return headcount ? headcount : 0;
  };

  const handleSubmit = async () => {
    let month = months.filter(
      (item: any) => item.value == getValue(orgParams, `date`, "").split("-")[1]
    )[0];
    let year = years.filter(
      (item: any) => item.value == getValue(orgParams, `date`, "").split("-")[0]
    )[0];
    const formValid = simpleValidator.current.allValid();
    if (!formValid) {
      simpleValidator.current.showMessages();
      forceUpdate(1);
    } else {
      if (calculateHeadCount() > 0) {
        if (
          calculateHeadCount() ===
          parseInt(getValue(request, `verified_male`, 0)) +
            parseInt(getValue(request, `verified_female`, 0))
        ) {
          let payload = {
            verified_headcount: calculateHeadCount(),
            verified_male: parseInt(getValue(request, `verified_male`, 0)),
            verified_female: parseInt(getValue(request, `verified_female`, 0)),
            month: parseInt(getValue(month, `value`, "")),
            year: parseInt(getValue(year, `value`, "")),
            location_id: selectedLocation.location_id,
            vendor_id: orgParams.id,
          };
          // if (!edit) {
          try {
            let resp = await clientCreateVerifiedHeadCount(payload);
            if (resp) {
              toast.success(getValue(resp, `message`, ""));
              handleModal();
              getData();
              reset();
              // setGroup_name("");
              // setEdit(false);
              // setEditId("");
            }
          } catch (error) {}
          // } else {
          // 	try {
          // 		let resp = await clientUpdateSpecificHeadCount(editId, payload);
          // 		if (resp) {
          // 			toast.success(getValue(resp, `message`, ""));
          // 			handleModal();
          // 			reset();
          // 			getData();
          // 		}
          // 	} catch (error) {}
          // }
        } else {
          toast.error("Male + Female and Total Headcount should be equal");
        }
      } else {
        toast.error("Headcount is mandatory field");
      }
    }
  };

  const reset = () => {
    setEdit(false);
    setRequest({
      ...request,
      verified_headcount: "",
      verified_male: "",
      verified_female: "",
      month: "",
      year: "",
    });
    setSelectedMonth("");
    setSelectedYear("");
    setSelectedLocation("");
    setEditId("");
  };

  /* -------------------------------------------------------------------------- */
  /*                               Search section                               */
  /* -------------------------------------------------------------------------- */
  const [showSearchTextbox, setShowSearchTextbox] = useState(false);
  const [search_text, setSearchInput] = useState<any>("");

  const toggleSearch = () => {
    setShowSearchTextbox((prevState) => !prevState);
  };
  const toggleSearchClose = () => {
    setSearchInput("");
    toggleSearch();
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (params.search_text) {
      delete params.search_text;
      let payload: any = { ...params };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
      getData();
    }
  };

  const handleChangeSearch = async (e: any) => {
    setSearchInput(e.target.value);
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      page_no: 1,
      search_text: e.target.value,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    if (!e.target.value) {
      getData();
    }
  };

  const [selectedIDs, setSelectedIDs] = useState<any>([]);
  const getTableState = (value: object) => {
    let selectedIndexList = Object.keys(
      getValue(value, `selectedRowIds`, {})
    ).map((item) => parseInt(item));
    let selectedIds =
      list.length > 0
        ? list.filter((_item: object, index: number) =>
            selectedIndexList.includes(index)
          )
        : [];

    if (selectedIds.length > 0) {
      setSelectedIDs(
        selectedIds.map((item: object) => getValue(item, `id`, ""))
      );
    } else {
      setSelectedIDs([]);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                                 Delete section                             */
  /* -------------------------------------------------------------------------- */

  const [deleteValue, setDeleteValue] = useState("");
  const [deleteId, setDeleteId] = useState("");

  const handleDeleteBulk = async () => {
    try {
      let resp = await clientDeleteBulkHeadCount({ ids: selectedIDs });
      if (resp) {
        toast.success("Deleted successfully");
        getData();
      }
    } catch (error) {}
  };
  const handleDeleteFun = (e: any, id: string, value: string) => {
    e.stopPropagation();
    setDeleteValue(value);
    setDeleteId(id);
    handleDelete();
  };
  const [isDelete, setIsDelete] = useState(false);
  const handleDelete = () => {
    setIsDelete(!isDelete);
  };

  const handleDeleteFunction = async () => {
    try {
      let resp = await clientDeleteSpecificHeadCount(deleteId);
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        handleDelete();
        getData();
      }
    } catch (error) {}
  };

  /* -------------------------------------------------------------------------- */
  /*                               Onchange section                             */
  /* -------------------------------------------------------------------------- */

  const handleChangeSortBy = (value: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    params.sort_by = value;
    props.history.push({
      pathname: window.location.pathname,
      query: params,
    });
  };

  const handleChangeStatus = (value: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    params.status = value;
    props.history.push({
      pathname: window.location.pathname,
      query: params,
    });
  };

  const handleChangeText = (e: any) => {
    const { name, value } = e.target;
    setRequest({
      ...request,
      [name]: sanitizeInput(value),
    });
  };
  /* -------------------------------------------------------------------------- */
  /*                               Pagination section                           */
  /* -------------------------------------------------------------------------- */

  const [totalCount, setTotalCount] = useState(0);
  const [limit, setLimit] = useState(10);
  const [page_no, setPage_no] = useState(1);

  const handleChangePagination = (page_no: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload = {
      ...params,
      page_no: page_no,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const handleChangeLimit = (limit: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      limit: limit,
      page_no: "1",
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const handleEdit = (id: string) => {
    navigate(`/checkpoint/active-detail/${id}`);
  };
  const rowClick = (obj: object) => {
    handleModalEdit(obj);
    getLocationData(getValue(obj, `original.location.id`, ""));
  };

  const getTrProps = (rowInfo: any) => {
    if (getValue(rowInfo, `id`, "")) {
      return {
        style: {
          //   background:  'red',
          //   color: 'black'
        },
      };
    }
    return {};
  };
  const rowClickUpdate = () => {};
  const columns: any = React.useMemo(
    () => [
      {
        Header: "Vendor",
        accessor: "vendor_name",
        width: 90,
      },
      {
        Header: "Location",
        accessor: "location_name",
        width: 130,
      },
      {
        Header: "Verified Male HC",
        accessor: "verified_male",
        width: 120,
      },
      {
        Header: "Verified Female HC",
        accessor: "verified_female",
        width: 130,
      },
      {
        Header: "Total Verified HC",
        accessor: "verified_headcount",
        width: 120,
      },
      {
        Header: "Month",
        accessor: "yearMonth",
        width: 100,
      },
      // 		 {
      //   	Header: "Action",
      //   	width: 200,
      //   	Cell: ({ row }: any) => {
      //   		return (
      //   			<>
      //   				<Button
      //   					color="primary"
      //   					onClick={() => handleEdit(row.original.id)}
      //   				>
      //   					Edit
      //   				</Button>
      //   				&nbsp;&nbsp;&nbsp;
      //   				<Button
      //   					color="danger"
      //   					onClick={(e) =>
      //   						handleDeleteFun(
      // 							  e,
      //   							row.original.id,
      //   							row.values.location_name
      //   						)
      //   					}
      //   				>
      //   					Delete
      //   				</Button>
      //   			</>
      //   		);
      //   	},
      //   },
    ],
    []
  );

  const handleAdd = async (value: object) => {
    setSelectedLocation(value);
  };

  const handleChangeSelect = async (e: object, value: string) => {
    // setValue(request,`[${value}]`,getValue(e,`value`,''))
    if (value === "month") {
      setSelectedMonth(e);
    } else {
      setSelectedYear(e);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                      New Location Search Section                           */
  /* -------------------------------------------------------------------------- */

  const [searchLoading, setSearchLoading] = useState(false);
  const handleTriggerAPI = async (value: string) => {
    let payload: any = {
      // page_no: 1,
      // page_size: 10,
      // is_active: true,
      // search_text: value,
      month: orgParams.date.split("-")[1],
      year: orgParams.date.split("-")[0],
      type: "LOCATION",
      search_text: value,
      // location_id: id,
      page_size:  100,
      vendor_id: orgParams.id,
    };
    setSearchLoading(true);
    let queryRequest = QueryRequestHelper(payload);
    try {
      // let resp = await clientGetLocation(queryRequest);
      let resp = await getManageAuditScoreFilter(queryRequest);
      if (resp) {
        setLocationList(
          getValue(resp, `data.vendors_checkpoint`, []).map((item: any) => ({
            ...item,
            value: getValue(item, `location_name`, ""),
            label: getValue(item, `location_name`, ""),
          }))
        );
        setSelectedLocation("");
        setSearchLoading(false);
      } else {
        setSearchLoading(false);
      }
    } catch (error) {
      setSearchLoading(false);
    }
  };
  const handleClick = (e: any) => {
    setSelectedLocation(e);
    handleAdd(e);
    // handleSelectLocation(e);
  };

  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  const [check, setCheck] = useState(false);
  const handleRemoveNavItems = () => {
    setCheck(!check);
    setSelectedIDs([]);
  };
  const calculateTotal = () => {
    setRequest({
      ...request,
      verified_headcount:
        (getValue(request, `verified_male`, 0)
          ? parseInt(getValue(request, `verified_male`, 0))
          : 0) +
        (getValue(request, `verified_female`, 0)
          ? parseInt(getValue(request, `verified_female`, 0))
          : 0),
    });
  };

  const handleAddFun = () => {
    handleModal();
  };

  const urlParamsFun = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let request = QueryRequestHelper({ ...params });
    return request;
  };

  const mainQueryRequest = useMemo(() => urlParamsFun(), [
    window.location.href,
  ]);

  console.log(getValue(orgParams, `date`, ""), "orgPArams date");
  console.log(getValue(orgParams, `date`, "").split("-")[0]);
  console.log(years, "years")
  console.log(months.filter(
    (item: any) =>
      item.value ==
      getValue(orgParams, `date`, "").split("-")[1]
  )[0], "months");

  console.log(years.filter(
    (item: any) =>
      item.value ==
      getValue(orgParams, `date`, "").split("-")[0]
  )[0], "years")

  return (
    <DashboardLayout
      permissions={getValue(props, `tabPermissionList`, [])}
      subTabPermissionList={getValue(props, `subTabPermissionList`, [])}
    >
      <div>
        <div className="dashboard-wrapper__header d-flex mb-1 justify-content-between align-items-center d-none">
          <div className="d-flex">
            <NavLink
              to={`/audit/details/${getValue(orgParams, `id`, "")}/${getValue(
                orgParams,
                `date`,
                ""
              )}/${getValue(orgParams, `route`, "")}/${getValue(
                orgParams,
                `name`,
                ""
              )}?${mainQueryRequest}`}
              className="mt-1"
            >
              <img src="/images/back-link.svg" className="img-fluid" />
            </NavLink>
            &nbsp;&nbsp;&nbsp;
            <h6 className="mt-1">
              {getValue(orgParams, `name`, "")} -{" "}
              {moment(getValue(orgParams, `date`, "")).format("MMM, YYYY")}
            </h6>
          </div>
        </div>

        {getValue(selectedIDs, `length`, 0) > 0 && (
          <NavigationBar
            selectedIDs={selectedIDs}
            isMarkInactiveSectionVisible={false}
            handleChangeActiveStatus={handleChangeActiveStatus}
            text={"MARK INACTIVE"}
            handleRemoveNavItems={handleRemoveNavItems}
            handleDeleteFun={handleDeleteBulk}
            delete={
              getValue(props, `permissions`, []).includes("delete")
                ? true
                : false
            }
          />
        )}

          <div className="dashboard-wrapper__header d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <NavLink
                to={`/audit/details/${getValue(orgParams, `id`, "")}/${getValue(
                  orgParams,
                  `date`,
                  ""
                )}/${getValue(orgParams, `route`, "")}/${getValue(
                  orgParams,
                  `name`,
                  ""
                )}?${mainQueryRequest}`}
                className="me-2"
              >
                <img src="/images/back-link.svg" className="img-fluid" />
              </NavLink>
              <div className="header-parent-icon-holder">
                <MenuAuditSvgComponent />
              </div>

              <div className="title-wrapper">
                <h6 className="dashbaord-wrapper__header-parent-title">
                  Vendor Audit - Head Count
                </h6>
                <h4 className="dashbaord-wrapper__header-title">
                  <span>
                    {getValue(orgParams, `name`, "")} -{" "}
                    {moment(getValue(orgParams, `date`, "")).format("MMM, YYYY")}
                  </span>
                </h4>
              </div>
            </div>

            <div className="d-flex align-items-center">
              {getValue(props, `permissions`, []).includes("update") && (
              <div className="d-flex justify-content-between">
                <ReactTooltip id="headCountAdd" effect="solid" place="bottom">
                  Add 
                </ReactTooltip>
                <div
                  className="filter-form-wrappper__location flex-1"
                  style={{ marginLeft: "20px" }}
                >
                  <div
                    className="add-filter-wrapper__add-icon d-flex d-flex cursor-pointer align-items-center justify-content-center"
                    onClick={() => handleAddFun()}
                    data-tip
                    data-for="headCountAdd"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      width="24"
                    >
                      <path
                        d="M11 19V13H5V11H11V5H13V11H19V13H13V19Z"
                        fill="#ffffff"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            )}
              <RightMenuHeaders
                //search
                isSearch={true}
                searchInput={search_text}
                showSearchTextbox={showSearchTextbox}
                toggleSearch={toggleSearch}
                toggleSearchClose={toggleSearchClose}
                handleChangeSearch={handleChangeSearch}
                //Line Seperator of button
                lineSeperator={true}
              />
            </div>
          </div>
        
        <div className="main-page-layout-wrapper"
          id={
            getValue(selectedIDs, `length`, 0) > 0
              ? "blueNavigationVisible"
              : ""
          }
        >
          <section className="add-filter-wrapper add-filter-wrapper d-flex align-items-center justify-content-between mb-4 d-none">
            {getValue(props, `permissions`, []).includes("update") && (
              <div className="d-flex justify-content-between">
                <div
                  className="filter-form-wrappper__location flex-1"
                  style={{ marginLeft: "20px" }}
                >
                  <div
                    className="add-filter-wrapper__add-icon d-flex"
                    onClick={() => handleAddFun()}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      width="24"
                    >
                      <path
                        d="M11 19V13H5V11H11V5H13V11H19V13H13V19Z"
                        fill="#ffffff"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            )}
            <div>
              <Search
                searchInput={search_text}
                showSearchTextbox={showSearchTextbox}
                toggleSearch={toggleSearch}
                toggleSearchClose={toggleSearchClose}
                handleChangeSearch={handleChangeSearch}
              />
            </div>
          </section>
          {isLoading ? (
            <Loader />
          ) : list.length > 0 ? (
            getValue(props, `permissions`, []).includes("update") ? (
              <ScrollableReactTable
                columns={columns}
                data={list}
                getTableState={getTableState}
                rowClick={rowClick}
                check={check}
                selectedIDs={selectedIDs}
                getTrProps={getTrProps}
              />
            ) : (
              <ScrollableReactTable
                columns={columns}
                data={list}
                getTableState={getTableState}
                rowClick={rowClickUpdate}
                check={check}
                selectedIDs={selectedIDs}
                getTrProps={getTrProps}
              />
            )
          ) : (
            <>
              {Object.keys(params).length !== 0 ? (
                <>
                  <Notfound />
                </>
              ) : (
                <Notfound />
              )}
            </>
          )}
          <div className="footer-wrapper d-flex justify-content-between">
          {list.length > 0 && (
            <img src="/images/building-illustration.svg" className="img-fluid" />
          )}
          {totalCount > 10 ? (
            <PaginationPage
              totalCount={totalCount}
              limit={limit}
              pageNumber={page_no}
              handleChangePagination={handleChangePagination}
              handleChangeLimit={handleChangeLimit}
            />
          ) : (
            <p className="show-rows-count mt-3 d-flex">
              Total Count:&nbsp;&nbsp;{" "}
              <p style={{ color: "rgb(13, 110, 253)" }}>{totalCount}</p>
            </p>
          )}
        </div>
        </div>
        
        <DeleteModal
          isOpen={isDelete}
          handleModal={handleDelete}
          handleSubmit={handleDeleteFunction}
          deleteValue={deleteValue}
        />
        <Modal
          centered
          isOpen={isOpen}
          className="headcount-popup-wrapper"
          // toggle={isOpen}
        >
          <ModalBody>
            <div className="headcount-popup-wrapper__image">
              <img
                src="/images/popup/popup-illustration.svg"
                className="img-fluid"
              />
            </div>
            <h3 className="headcount-popup-wrapper__title text-center">
              Verified Headcount
            </h3>
            <div className="headcount-popup-wrapper__form">
              <div className="headcount-popup-wrapper__form-group">
                <Label>Male Headcount</Label>
                <InputField
                  inputType="NUMBER"
                  value={getValue(request, `verified_male`, "")}
                  onChange={(e: any) => handleChangeText(e)}
                  name="verified_male"
                  id="verified_male"
                  placeholder={"Enter Male Header Count"}
                  // validator={simpleValidator}
                  label={"Male Headcount"}
                />
              </div>
              <div className="headcount-popup-wrapper__form-group">
                <Label>Female Headcount</Label>
                <InputField
                  inputType="NUMBER"
                  value={getValue(request, `verified_female`, "")}
                  onChange={(e: any) => handleChangeText(e)}
                  name="verified_female"
                  id="verified_female"
                  placeholder={"Enter Female Header Count"}
                  // validator={simpleValidator}
                  label={"verified_female"}
                />
              </div>
              <div className="headcount-popup-wrapper__form-group">
                <Label className="d-flex">
                  Total Headcount &nbsp;{" "}
                  <p
                    style={{ color: "#276ef1", cursor: "pointer" }}
                    onClick={calculateTotal}
                  >
                    ( Click to Update Male+Female )
                  </p>
                </Label>
                <InputField
                  inputType="NUMBER"
                  value={getValue(request, `verified_headcount`, "")}
                  onChange={(e: any) => handleChangeText(e)}
                  name="verified_headcount"
                  id="verified_headcount"
                  placeholder={"Enter Header Count"}
                  // validator={getValue(request, `verified_female`, "") || getValue(request, `verified_male`, "")?'':simpleValidator}
                  label={"Headcount"}
                  disabled={
                    getValue(request, `verified_female`, "") ||
                    getValue(request, `verified_male`, "")
                  }
                />
              </div>
              <div className="headcount-popup-wrapper__form-group">
                <Label className="headcount-popup-wrapper__form-label">
                  Month
                </Label>
                <InputField
                  inputType="INPUT_REACT_SELECT"
                  value={
                    months.filter(
                      (item: any) =>
                        item.value ==
                        getValue(orgParams, `date`, "").split("-")[1]
                    )[0]
                  }
                  placeholder="Select"
                  options={months}
                  onChange={(e: any) => handleChangeSelect(e, "month")}
                  label="Month"
                  validator={simpleValidator}
                  className="headcount-popup-wrapper__select"
                  disabled
                />
              </div>
              <div className="headcount-popup-wrapper__form-group">
                <Label className="headcount-popup-wrapper__form-label">
                  Year
                </Label>
                <InputField
                  inputType="INPUT_REACT_SELECT"
                  value={
                    years.filter(
                      (item: any) =>
                        item.value ==
                        getValue(orgParams, `date`, "").split("-")[0]
                    )[0]
                  }
                  placeholder="Select"
                  options={years}
                  onChange={(e: any) => handleChangeSelect(e, "year")}
                  label="Year"
                  validator={simpleValidator}
                  className="headcount-popup-wrapper__select"
                  disabled
                />
              </div>
              <div className="headcount-popup-wrapper__form-group">
                <Label className="headcount-popup-wrapper__form-label">
                  Location
                </Label>
                {/* <InputField
                  inputType="INPUT_REACT_SELECT"
                  value={selectedLocation}
                  placeholder="Select"
                  options={locationList}
                  onChange={(e: any) => handleAdd(e)}
                  label="Location"
                  validator={simpleValidator}
                  className="headcount-popup-wrapper__select"
                /> */}
                <SearchableDropdownSelect
                  placeholder={"Search Location"}
                  options={locationList}
                  searchLoading={searchLoading}
                  handleChange={(val: any) => handleTriggerAPI(val)}
                  handleClick={handleClick}
                  value={selectedLocation}
                  label="label"
                  id="id"
                  name="Location"
                  validator={simpleValidator}
                />
              </div>
            </div>
            <div className="add-popup-wrapper__cta-wrapper pb-4 mt-3">
              <button
                onClick={handleModalCancel}
                className="add-popup-wrapper__cta-btn add-popup-wrapper__cta-btn--secondary"
              >
                Cancel
              </button>
              <button
                className="add-popup-wrapper__cta-btn add-popup-wrapper__cta-btn--primary"
                onClick={handleSubmit}
              >
                {edit ? "Update" : "Submit"}
              </button>
            </div>
          </ModalBody>
        </Modal>
      </div>
    </DashboardLayout>
  );
};

export default AuditHeadCount;
